// Define utility classes to reduce repetition
export const rowStyles = "font-arial text-base font-normal leading-6 cursor-pointer w-[1372px] h-[83px]"
export const iconStyles = "hover:text-green-800 text-icons";
export const tabClass = (active: boolean) =>
  `px-4 py-2 text-sm font-medium border-b-2 font-arial font-bold text-[16px] leading-[24px] tracking-normal
  ${
    active
      ? "border-[#B60F8D] text-[#B60F8D] bg-white hover:bg-[#FDE7F2] hover:text-black hover:border-[#B60F8D]/30 bg-transparent "
      : "border-[#B60F8D]/30 bg-transparent text-[#B60F8D] hover:text-black hover:bg-[#FDE7F2] hover:border-gray-300 focus:border-2 focus:border-[#B60F8D] focus:text-black focus:bg-white focus:outline-none"
  }`;